import React from "react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="container legal-page">
      <Link to="/" className="back-link">
        <span>←</span> Back to home
      </Link>
      <h1>Terms of Service</h1>
      <p className="effective-date">
        <strong>Effective Date: May 2, 2026</strong>
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By adding the <strong>Kami</strong> to your server or interacting
        with its services, you agree to be bound by these Terms of Service.
      </p>

      <h2>2. Use of Service</h2>
      <ul>
        <li>
          <strong>Eligibility:</strong> You must be at least 13 years of age to
          use this service.
        </li>
        <li>
          <strong>Conduct:</strong> Users must not use the bot to harass others
          or violate Discord’s Terms of Service.
        </li>
        <li>
          <strong>Abuse:</strong> Any attempt to exploit bot mechanics or farm
          currency through automation is prohibited.
        </li>
      </ul>

      <h2>3. Limitations of Liability</h2>
      <p>
        The Nocturne project provides this service "as-is." We are not
        responsible for any data loss resulting from the use of the bot.
      </p>
    </div>
  );
};

export default TermsOfService;
